(function () {
  if (window.lcConditionInfoLoaded) return;
  window.lcConditionInfoLoaded = true;

  function norm(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLocaleLowerCase();
  }

  var labelMaps = {
    en: {
      mint: 'Mint',
      'near-mint': 'Near Mint',
      excellent: 'Excellent',
      'lightly-played': 'Lightly Played',
      'moderately-played': 'Moderately Played',
      'heavily-played': 'Heavily Played',
      damaged: 'Damaged'
    },
    nl: {
      mint: 'Nieuwstaat',
      'near-mint': 'Near Mint',
      excellent: 'Lichte gebruikssporen',
      'lightly-played': 'Zichtbaar gebruikt',
      'moderately-played': 'Licht gespeeld',
      'heavily-played': 'Zwaar gespeeld',
      damaged: 'Sterk beschadigd'
    },
    de: {
      mint: 'Neuwertig',
      'near-mint': 'Nahezu neuwertig',
      excellent: 'Sehr gut',
      'lightly-played': 'Leicht gespielt',
      'moderately-played': 'Mäßig gespielt',
      'heavily-played': 'Stark gespielt',
      damaged: 'Beschädigt'
    },
    fr: {
      mint: 'Neuve',
      'near-mint': 'Quasi neuve',
      excellent: 'Excellente',
      'lightly-played': 'Légèrement jouée',
      'moderately-played': 'Modérément jouée',
      'heavily-played': 'Très jouée',
      damaged: 'Endommagée'
    },
    es: {
      mint: 'Nueva',
      'near-mint': 'Casi nueva',
      excellent: 'Excelente',
      'lightly-played': 'Poco jugada',
      'moderately-played': 'Moderadamente jugada',
      'heavily-played': 'Muy jugada',
      damaged: 'Dañada'
    },
    it: {
      mint: 'Nuova',
      'near-mint': 'Quasi nuova',
      excellent: 'Eccellente',
      'lightly-played': 'Poco giocata',
      'moderately-played': 'Moderatamente giocata',
      'heavily-played': 'Molto giocata',
      damaged: 'Danneggiata'
    }
  };

  var aliases = {
    mint: ['mint', 'mt', 'nieuwstaat', 'neuwertig', 'neuve', 'nueva', 'nuova'],
    'near-mint': ['near mint', 'near-mint', 'nm', 'bijna nieuw', 'nahezu neuwertig', 'quasi neuve', 'casi nueva', 'quasi nuova'],
    excellent: ['excellent', 'ex', 'lichte gebruikssporen', 'sehr gut', 'excellente', 'excelente', 'eccellente'],
    'lightly-played': ['good', 'slightly played', 'slightly-played', 'lightly played', 'lightly-played', 'gd', 'zichtbaar gebruikt', 'leicht gespielt', 'légèrement jouée', 'poco jugada', 'poco giocata'],
    'moderately-played': ['light played', 'light-played', 'moderately played', 'moderately-played', 'lp', 'mp', 'licht gespeeld', 'mäßig gespielt', 'modérément jouée', 'moderadamente jugada', 'moderatamente giocata'],
    'heavily-played': ['played', 'heavily played', 'heavily-played', 'pl', 'hp', 'zwaar gespeeld', 'stark gespielt', 'très jouée', 'muy jugada', 'molto giocata'],
    damaged: ['poor', 'damaged', 'po', 'dmg', 'sterk beschadigd', 'beschädigt', 'endommagée', 'dañada', 'danneggiata']
  };

  var aliasKeys = {};
  var locale = String(document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
  var labels = labelMaps[locale] || labelMaps.en;

  Object.keys(aliases).forEach(function (key) {
    aliases[key].forEach(function (alias) {
      aliasKeys[norm(alias)] = key;
    });
  });

  function conditionKey(value) {
    if (window.lcConditionLabels && typeof window.lcConditionLabels.conditionKey === 'function') {
      var sharedKey = window.lcConditionLabels.conditionKey(value);
      if (sharedKey) return sharedKey;
    }
    return aliasKeys[norm(value)] || '';
  }

  function customerCondition(key, fallback) {
    if (window.lcConditionLabels && typeof window.lcConditionLabels.labelFor === 'function') {
      var sharedLabel = window.lcConditionLabels.labelFor(key);
      if (sharedLabel) return sharedLabel;
    }
    return labels[key] || String(fallback || '').replace(/\s+/g, ' ').trim();
  }

  function LcConditionInfoClass() {
    return class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.scope = this.closest('.variant-option') || this.parentElement || this;
        this.btn = this.scope.querySelector('.lc-cond-btn');
        this.line = this.querySelector('[data-lc-cond-line]');
        this.lineText = this.querySelector('[data-lc-cond-line-text]');
        this.valueEl = this.scope.querySelector('[data-selected-value]');
        this.rows = Array.prototype.slice.call(this.querySelectorAll('[data-cond]'));

        this._onBtnClick = function (event) {
          event.preventDefault();
          event.stopPropagation();
          this.toggle();
        }.bind(this);

        this._onDocClick = function (event) {
          if (!this.classList.contains('is-open')) return;
          if (this.contains(event.target)) return;
          if (this.btn && this.btn.contains(event.target)) return;
          this.close();
        }.bind(this);

        this._onKeydown = function (event) {
          if (event.key !== 'Escape') return;
          if (!this.classList.contains('is-open')) return;
          this.close();
          if (this.btn) this.btn.focus();
        }.bind(this);

        this._onChange = this.sync.bind(this);

        if (this.btn) this.btn.addEventListener('click', this._onBtnClick);

        var closeBtn = this.querySelector('[data-lc-cond-close]');
        if (closeBtn) {
          closeBtn.addEventListener(
            'click',
            function (event) {
              event.preventDefault();
              this.close();
              if (this.btn) this.btn.focus();
            }.bind(this)
          );
        }

        document.addEventListener('click', this._onDocClick);
        document.addEventListener('keydown', this._onKeydown);
        this.scope.addEventListener('change', this._onChange);

        if (this.valueEl && 'MutationObserver' in window) {
          this._observer = new MutationObserver(this._onChange);
          this._observer.observe(this.valueEl, {
            childList: true,
            characterData: true,
            subtree: true
          });
        }

        this.sync();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this._onDocClick);
        document.removeEventListener('keydown', this._onKeydown);
        if (this.scope) this.scope.removeEventListener('change', this._onChange);
        if (this._observer) this._observer.disconnect();
        this._ready = false;
      }

      sync() {
        var currentText = this.valueEl ? this.valueEl.textContent : '';
        var key = conditionKey(currentText);
        var customerText = customerCondition(key, currentText);
        var match = null;

        if (this.valueEl && key && currentText.trim() !== customerText) {
          this.valueEl.textContent = customerText;
        }

        this.rows.forEach(function (row) {
          var isCurrent = row.getAttribute('data-cond') === key;
          row.classList.toggle('is-current', isCurrent);
          if (isCurrent) match = row;
        });

        if (!this.line || !this.lineText) return;

        if (match) {
          this.lineText.textContent = match.getAttribute('data-short') || '';
          this.line.classList.add('is-visible');
        } else {
          this.lineText.textContent = '';
          this.line.classList.remove('is-visible');
        }
      }

      toggle() {
        if (this.classList.contains('is-open')) {
          this.close();
        } else {
          this.open();
        }
      }

      open() {
        this.classList.add('is-open');
        if (this.btn) this.btn.setAttribute('aria-expanded', 'true');
      }

      close() {
        this.classList.remove('is-open');
        if (this.btn) this.btn.setAttribute('aria-expanded', 'false');
      }
    };
  }

  if (!customElements.get('lc-condition-info')) {
    customElements.define('lc-condition-info', LcConditionInfoClass());
  }
})();
